import padStart from 'lodash/padStart'

export default function formatDuration (milliseconds, visibilityOptions = { hours: 'auto', seconds: 'visible', words: 'auto' }) {
  let seconds = Math.floor(milliseconds / 1000)

  const hours = Math.floor(seconds / 3600)

  seconds = seconds - hours * 3600
  const minutes = Math.floor(seconds / 60)

  seconds = seconds - minutes * 60

  const H = hours
  const mm = padStart(minutes, 2, '0')
  const ss = padStart(seconds, 2, '0')

  let duration = ''

  if (visibilityOptions.hours === 'visible') {
    duration = H
    if (visibilityOptions.words === 'visible') {
      duration = duration + 'h'
    }
  } else if (visibilityOptions.hours === 'auto') {
    if (hours > 0) {
      duration = H
      if (visibilityOptions.words === 'visible') {
        duration = duration + 'h'
      }
    }
  }

  if (duration !== '') {
    if (visibilityOptions.words === 'visible' && minutes > 0) {
      duration = duration + ` ${minutes}m`
    } else {
      duration = duration + `:${mm}`
    }
  } else {
    if (visibilityOptions.words === 'visible' && minutes > 0) {
      duration = minutes + 'm'
    } else {
      if (visibilityOptions.words !== 'visible') {
        duration = mm
      }
    }
  }

  if (visibilityOptions.seconds === 'visible') {
    if (visibilityOptions.words === 'visible') {
      duration = duration + ` ${seconds}s`
    } else {
      duration = duration + `:${ss}`
    }
  }

  return duration
}



// WEBPACK FOOTER //
// ./~/vue-components/utils/format-duration.js